// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"5ab7cf0f","314":"2549f660","352":"3595b251","947":"4507cbba"}[chunkId] + ".chunk.css";
};